const THEMES = {
  default: {
    primary: '#3B82F6',
    secondary: '#3B82F6', 
    accent: '#8B5CF6',
    error: '#EF4444',
    warning: '#F59E0B',
    info: '#06B6D4',
    success: '#22C55E',
    background: 'from-rose-100 to-teal-100',
    darkBackground: 'from-slate-900 dark:to-slate-800'
  },
  ocean: {
    primary: '#0EA5E9',
    secondary: '#0891B2',
    accent: '#6366F1',
    error: '#F43F5E',
    warning: '#FB923C',
    info: '#38BDF8',
    success: '#10B981',
    background: 'from-cyan-100 to-blue-100',
    darkBackground: 'from-blue-900 to-cyan-900'
  },
  sunset: {
    primary: '#F97316',
    secondary: '#fa7028',
    accent: '#EC4899',
    error: '#DC2626',
    warning: '#FBBF24',
    info: '#38BDF8',
    success: '#16A34A',
    background: 'from-orange-100 to-rose-100',
    darkBackground: 'from-orange-900 to-rose-900'
  },
  forest: {
    primary: '#16A34A',
    secondary: '#1cb053',
    accent: '#4ADE80',
    error: '#DC2626',
    warning: '#F59E0B',
    info: '#0EA5E9',
    success: '#22C55E',
    background: 'from-emerald-100 to-lime-100',
    darkBackground: 'from-emerald-900 to-lime-900'
  }
};

export default THEMES; 